import { DefaultOptionType } from 'antd/lib/select'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { ButtonMain } from '~src/components/global/Button/ButtonMain/ButtonMain'
import { FormSelect } from '~src/components/global/FormControls/FormSelect'
import { useCategoryChildren, useCategoryChildrenByUid } from '~src/hook/useCategoryChildren'
import { encode, removeEmptyValueFromObject, sortByPosition } from '~src/util'
import { ListSearch } from './ListSearch'
import { Input } from 'antd'

export const BoxSearch = ({
  defaultFilter,
  loadingFilter,
}: {
  defaultFilter?: TDefaultWebsiteFilter
  loadingFilter: boolean
}) => {
  const router = useRouter()
  const { control, handleSubmit, setValue, getValues, watch } = useForm<BoxSearchForm>({
    defaultValues: {
      type: null,
      company: null,
      end: null,
      groupAccessary: null,
      search: null,
    },
  })

  // Hãng xe → Dòng xe → Đời xe, dùng chung cache với trang catalog-category
  const rootUid =
    defaultFilter?.hang_xe && !loadingFilter ? encode(String(defaultFilter.hang_xe)) : null
  const { data: companies } = useCategoryChildrenByUid(rootUid)
  const { data: types } = useCategoryChildren(watch('company'))
  const { data: ends } = useCategoryChildren(watch('type'))

  // Magento không trả children theo position nên sắp lại cho khớp thứ tự menu header
  const dataCategoriesByCompany = useMemo(() => sortByPosition(companies ?? []), [companies])
  const dataCategoriesByType = useMemo(() => sortByPosition(types ?? []), [types])
  const dataCategoriesByEnd = useMemo(() => sortByPosition(ends ?? []), [ends])

  // Danh sách nhóm phụ tùng
  // const {
  //   data: dataSpareParts,
  //   isLoading: isLoadingDataSpareParts,
  // }: {
  //   data?: TChildrenCategories[]
  //   isLoading?: boolean
  // } = useQuery({
  //   queryKey: ['getSpareParts'],
  //   queryFn: async () => {
  //     const data = (await graphQLClient.request(GET_CATEGORIES, {
  //       eq: 'NTU=',
  //     })) as TCategories
  //     return data.categories?.items[0]?.children
  //   },
  // })

  const handleSelectCategoryCompany = (
    value: any,
    option?: DefaultOptionType | DefaultOptionType[] | undefined
  ) => {
    setValue('type', null)
  }

  const onSubmit = (data: BoxSearchForm) => {
    const pathname =
      '/catalog-category' +
      (data?.company ? `/${data?.company}` : '') +
      (data?.type ? `/${data?.type}` : '') +
      (data?.end ? `/${data?.end}` : '') +
      (data?.tag ? `/${data?.tag}` : '')

    // const pathname = '/catalog-category' + (data?.end ? `/${data?.end}` : '')

    router.push({
      pathname: pathname,
      query: removeEmptyValueFromObject({ ...data, submitted: true }),
    })
  }

  return (
    <div className="box-search">
      <div className="bg-search">
        <img src="/image/search-banner.png" alt="" />
      </div>
      <div className="containers">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="group-box">
            <div className="box">
              <div className="items">
                <div className="item">
                  <FormSelect
                    control={control}
                    name={'company'}
                    optionList={dataCategoriesByCompany?.map((company: TChildrenCategories) => {
                      return {
                        label: company?.name,
                        value: company?.url_key,
                      }
                    })}
                    label="Hãng xe"
                    placeholder="Chọn hãng xe"
                    onChange={handleSelectCategoryCompany}
                  />
                </div>
                <div className="item">
                  <FormSelect
                    control={control}
                    name={'type'}
                    optionList={dataCategoriesByType?.map((type: TChildrenCategories) => {
                      return {
                        label: type?.name,
                        value: type?.url_key,
                      }
                    })}
                    label="Dòng xe"
                    placeholder="Chọn dòng xe"
                    disabled={!watch('company')}
                  />
                </div>
                <div className="item ">
                  <div className="w-full">
                    <div className="label-form">
                      <label className="" htmlFor={'search'}>
                        Từ khóa tìm kiếm
                      </label>
                    </div>
                  </div>
                  <Input
                    placeholder="Nhập tên sản phẩm, thương hiệu,..."
                    onChange={(event) => {
                      setValue('search', event.target.value)
                    }}
                  />
                  {/* <FormSelect
                    control={control}
                    name={'groupAccessary'}
                    optionList={dataSpareParts?.map((sparePart: TChildrenCategories) => {
                      return {
                        label: sparePart?.name,
                        value: sparePart?.uid,
                      }
                    })}
                    label="Nhóm phụ tùng"
                    placeholder="Chọn nhóm phụ tùng"
                  /> */}
                </div>
              </div>

              <div className="button-search">
                <ButtonMain background="green" type="submit">
                  <div className="flex items-center gap-[0.4rem]">
                    <div className="icon">
                      <img src="/icons/search-icon.svg" alt="" />
                    </div>
                    <div className="text">Tìm kiếm</div>
                  </div>
                </ButtonMain>
              </div>
            </div>
          </div>

          <ListSearch
            dataCategoriesByCompany={dataCategoriesByCompany || []}
            dataCategoriesByType={dataCategoriesByType || []}
            dataCategoriesByEnd={dataCategoriesByEnd || []}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            onSubmit={handleSubmit(onSubmit)}
            defaultFilter={defaultFilter}
          />
        </form>
      </div>
    </div>
  )
}
